import { peticionesReceiver } from "../../../helpers/peticionesReceiver";
import Notification from "../../../components/Notification/Notification";
import { toast } from "react-toastify";
const API = peticionesReceiver();

export const createCounty = async (distN) => {
  console.log(distN);
  if (distN) {
    console.log(distN);
    const params = {
      action: "insert",
      table: "counties",
      rows: distN,
      validate: [
        ["keyState", "nameCounty", "keyDistrict"],
        ["nameCounty", "keyDistrict"],
        ["nameCounty", "keyState"],
        ["economicKey"]
      ],
    };
    API.peticion(params)
      .then((res) => {
        if (res.status === 200 && res.data.code === "200") {
          toast(
            <Notification
              type={"agrega_exito"}
              backMessage={res.data.message}
              withIcon
            />
          );
          window.location.href = "#/template/municipios";
        } else {
          toast(
            <Notification
              type={"agrega_error"}
              backMessage={res.data.message}
              withIcon
            />
          );
        }
      })
      .catch((err) => {
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
  }
};

export const updateCounty = async (distU) => {
  if (distU) {
    const params = {
      action: "update",
      table: "counties",
      rows: distU,
      condition: {
        keyCounty: distU.keyCounty,
      },
      validate: [
        ["keyState", "nameCounty", "keyDistrict"],
        ["nameCounty", "keyDistrict"],
        ["nameCounty", "keyState"],
        ["economicKey"]
      ],
    };
    API.peticion(params)
      .then((res) => {
        if (res.status === 200 && res.data.code === "200") {
          toast(
            <Notification
              type={"modifica_exito"}
              backMessage={res.data.message}
              withIcon
            />
          );
          window.location.href = "#/template/municipios";
        } else {
          toast(
            <Notification
              type={"modifica_error"}
              backMessage={res.data.message}
              withIcon
            />
          );
        }
      })
      .catch((err) => {
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
  }
};
